import {
  IsInt,
  IsString,
  IsOptional,
  Min,
  IsEnum,
  IsNotEmpty,
} from "class-validator";
import { InstallLocation } from "./install-location.enum";
import { Expose } from "class-transformer";

export class UpdateManyProjectElementsDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  projectElementName: string;

  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  selectedPriceHigh?: number | null;

  @Expose()
  @IsOptional()
  @IsEnum(InstallLocation)
  installLocation?: InstallLocation | null;

  @Expose()
  @IsOptional()
  @IsString()
  notes?: string;

  @Expose()
  @IsOptional()
  @IsInt()
  @Min(0)
  priority?: number;
}
